"use strict";

exports.__esModule = true;
exports.default = void 0;
const getBasis = basis => ({
  theme
}) => {
  if (typeof basis === "undefined") return "";
  if (typeof basis === "function") return basis(theme);
  return basis;
};
var _default = getBasis;
exports.default = _default;